
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Newnavbar from "../Component/Newnavbar.js";
import Menudata from "../Component/Menudata.js";
import menu1 from "../Component/grocerybanner.png";
import "./housemaamaas.css";
import "./Style.css";
import Selectslot from "./Selectslot";
import SidescrollAdvertisements from "./SidescrollAdvertisements";
import { useLoader } from "././Context/LoaderProvider.jsx";
const Homemaamaas = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coupons, setCoupons] = useState([]);
  const [bannerData, setBannerData] = useState(null);
  const scrollContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);

  useEffect(() => {
  showLoader();  // 🔥 Start loader

  const vendorId = localStorage.getItem("vendorId") || 3;
  const token = localStorage.getItem("authToken");

  axios
    .get(
      ` https://backend.maamaas.com/food/api/banner/${vendorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      setBannerData({
        ...res.data,
        companyLogo: toImageSrc(res.data.companyLogo),
        companyName: res.data.companyName,
      });
    })
    .catch((err) => {
      console.error("❌ Failed to fetch vendor banner:", err);
    })
    .finally(() => {
      hideLoader();  // 🔥 Stop loader after success OR error
    });
}, []);


  const toImageSrc = (raw) => {
    if (!raw || raw.trim() === "/") return "/placeholder.svg";
    if (raw.startsWith("data:image")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.length > 100) return `data:image/jpeg;base64,${raw}`;
    return "/placeholder.svg";
  };

  const sidebarItems = [
    // {
    //   label: bannerData?.companyName || "Company Name",
    //   link: "/",
    //   img: bannerData?.companyLogo || "/placeholder.png",
    // },
    {
      label: "Menu",
      link: "/Newmenuiteam",
      img: bannerData?.companyLogo || "/placeholder.png",
    },
    {
      label: "Table Booking",
      link: "/tablebooking",
      img: bannerData?.companyLogo || "/placeholder.png",
    },
  ];

  useEffect(() => {
    axios
      .get(
        " https://backend.maamaas.com/food/api/coupon/vendor/3/active"
      )
      .then((res) => {
        if (res.data) {
          setCoupons(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching coupons:", err);
      });
  }, []);

  useEffect(() => {
    setCoupons([
      { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
      { code: "BURGER30", discountPercentage: 30, dishId: 2 },
      { code: "DEL99", discountPercentage: 20, dishId: 3 },
    ]);
  }, []);

  const dishImages = {
    1: { image: menu1 },
    2: { image: menu1 },
    3: { image: menu1 },
  };

  return (
    <div className="fullfile">
      {/* Mobile Breadcrumb - NOW POSITIONED AT THE TOP OF SIDEBAR */}
      {isMobile && (
        <div 
          className="mobile-breadcrumb"
          style={{
            position: "sticky",
            top: "0",
            left: "0",
            width: "100%",
            backgroundColor: "white",
            padding: "12px 15px",
            zIndex: 1000,
            borderBottom: "1px solid #e0e0e0",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          {bannerData && (
            <p
              style={{
                margin: "0",
                fontSize: "16px",
                fontWeight: "bold",
                textAlign: "center"
              }}
            >
              <Link
                to="/"
                style={{
                  color: "#ee6521",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                Home
              </Link>
              <span className="separator"> &gt; </span>
              <span style={{ color: "#ee6521", fontWeight: "bold" }}>
                {bannerData?.companyName || "Maamaas"}
              </span>
               <span className="separator"> &gt; </span>
              <span style={{ color: "#ee6521", fontWeight: "bold" }}>
                Tablebooking
              </span>
            </p>
          )}
        </div>
      )}

      <div className="container-fluid">
        <div className="row ms-0">
          {/* LEFT SIDEBAR */}
          <div className="col-lg-2 col-12 maamaas-home-data-top">
            {isMobile ? (
              <div 
                className="d-flex flex-column align-items-start"
                style={{ 
                  marginTop: "43px", // Reduced margin since breadcrumb is now at top
                  padding: "0 15px"
                }}
              >
                {/* पहला item */}
                <div
                  className="d-flex align-items-center p-2 w-100"
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={sidebarItems[0].img}
                    alt={sidebarItems[0].label}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      marginRight: "10px",
                      objectFit: "cover",
                    }}
                  />
                  <Link
                    to={sidebarItems[0].link}
                    style={{
                      fontWeight: "bold",
                      color: "#333",
                      textDecoration: "none",
                    }}
                  >
                    {sidebarItems[0].label}
                  </Link>
                </div>

                {/* Dropdown */}
                

                {isOpen && (
                  <div
                    className="d-flex flex-column mt-2 p-2 w-100"
                    style={{
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    {sidebarItems.slice(1).map((item, i) => (
                      <Link
                        key={i}
                        to={item.link}
                        className="d-flex align-items-center p-2"
                        style={{
                          textDecoration: "none",
                          borderBottom:
                            i !== sidebarItems.slice(1).length - 1
                              ? "1px solid #eee"
                              : "none",
                        }}
                      >
                        <img
                          src={item.img}
                          alt={item.label}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            marginRight: "10px",
                            objectFit: "cover",
                          }}
                        />
                        <span style={{ fontWeight: "bold", color: "#333" }}>
                          {item.label}
                        </span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="row gx-0 ms-0">
                {sidebarItems.map((item, i) => (
                  <div
                    key={i}
                    className="card d-flex justify-content-center align-items-center text-center"
                    style={{
                      width: "180px",
                      height: "180px",
                      backgroundColor: "#D9D9D9",
                      marginBottom: "20px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={item.img}
                      alt={item.label}
                      style={{
                        borderRadius: "50%",
                        width: "130px",
                        height: "130px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                    <Link
                      to={item.link}
                      className="btn mt-2"
                      style={{ backgroundColor: "#fff", fontWeight: "bold" }}
                    >
                      {item.label}
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* CENTER MENU */}
          <div className="col-lg-8 col-md-12 col-sm-12 col-12">
            {/* Desktop Breadcrumb */}
            {!isMobile && bannerData && (
  <p className="maamaas-home-bredcumsyy">
    <Link
      to="/"
      style={{
        color: "#ee6521",
        fontWeight: "bold",
        textDecoration: "none",
      }}
    >
      Home
    </Link>
    <span className="separator"> &gt; </span>
    <span style={{ color: "#ee6521", fontWeight: "bold" }}>
      {bannerData?.companyName || "Maamaas"}
    </span>
  </p>
)}

            <div
              style={{
                maxHeight: "1500px",
                overflowY: "scroll",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                marginTop: isMobile ? "10px" : "-39px"
              }}
            >
              <Selectslot />
            </div>
          </div>

          {/* RIGHT COUPONS */}
          <div
            className="col-lg-3"
            style={{ display: isMobile ? "none" : "block" }}
          >
            <SidescrollAdvertisements />
          </div>
        </div>
      </div>

      {/* Responsive CSS */}
      <style>{`
        @media screen and (max-width: 768px) {
          body, html {
            max-width: 100vw;
            overflow-x: hidden;
          }

          .fullfile {
            max-width: 100vw;
            overflow-x: hidden;
          }

          .container-fluid,
          .row.ms-0,
          .col-lg-8.col-md-12.col-sm-12.col-12 {
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          .col-lg-3 {
            display: none !important;
          }

          .card {
            width: 100% !important;
            height: auto !important;
          }

          .maamaas-home-data-top {
            margin-top: 0px;
          }

          /* Mobile breadcrumb fixed at top */
          .mobile-breadcrumb {
            position: fixed !important;
            top: 51 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
          }
        }

        @media screen and (max-width: 425px) {
          .maamaas-home-data-top {
            margin-top: 60px; /* Account for fixed breadcrumb height */
          }
        }
      `}</style>
    </div>
  );
};

export default Homemaamaas;